import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import { useMediaQueries } from 'src/common/providers/MediaQueryProvider';
import { PATHS } from '../../constants';
import NavItemDropdown from './NavItemDropdown';

type MyListingsNavItemProps = {
  classNameModifier?: string;
};

const MyListingsNavItem: FC<MyListingsNavItemProps> = ({ classNameModifier }) => {
  const [t] = useTranslation('navbar');
  const { m: isMediumAndUpScreenSize } = useMediaQueries();

  return (
    <NavItemDropdown
      classNameModifier={classNameModifier}
      icon="listings"
      options={[
        {
          dropdownLabel: t('my-listings--boats'),
          icon: isMediumAndUpScreenSize ? undefined : 'boat',
          id: PATHS.ADMIN_LISTINGS,
        },
        {
          dropdownLabel: t('my-listings--add-ons'),
          icon: isMediumAndUpScreenSize ? undefined : 'hand-coins',
          id: PATHS.ADMIN_ADDONS,
        },
      ]}
    >
      {t('my-listings')}
    </NavItemDropdown>
  );
};

export default MyListingsNavItem;
